import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/opencart': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zM169.4 394.9c25.3 0 45.8 20.5 45.8 45.8s-20.5 45.6-45.8 45.6c-25.3 0-45.6-20.4-45.6-45.6s20.3-45.8 45.6-45.8zM461.1 124.9c302.2 0 169.5 67.2-17.2 233.9 59.2-102.8 262.5-193.9-70.8-188.9-319.8 4.7-338.7-92.5-373.1-144.2 81.9 86.4 158.9 99.2 461.1 99.2z'
      }
    ]
  }
})
